// Backend-signed session token for email-OTP sign-ins (no Firebase account).
// email-otp issues it after a verified code; it is sent as the Bearer credential.

const KEY = 'vivideo_session_token';

/** Decoded payload of a vvs1 token ({e: email, x: expiry}), or {} when unreadable. */
function payloadOf(token: string): { e?: string; x?: number } {
  try {
    const payload = token.split('.')[1] || '';
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return {};
  }
}

/** Expiry (unix seconds) inside a vvs1 token, or 0 when unreadable. */
function expiryOf(token: string): number {
  return Number(payloadOf(token).x) || 0;
}

/** The email a vvs1 token was issued for (the backend verifies the signature). */
export function emailFromSessionToken(token: string): string | null {
  return token.startsWith('vvs1.') ? payloadOf(token).e || null : null;
}

export function setSessionToken(token: string | null | undefined): void {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch { /* storage unavailable */ }
}

/** The stored token while unexpired; null otherwise (an expired one is dropped). */
export function getSessionToken(): string | null {
  try {
    const token = localStorage.getItem(KEY);
    if (!token || !token.startsWith('vvs1.')) return null;
    if (expiryOf(token) * 1000 <= Date.now()) {
      localStorage.removeItem(KEY);
      return null;
    }
    return token;
  } catch {
    return null;
  }
}

export function clearSessionToken(): void {
  setSessionToken(null);
}
